module.exports = __webpack_public_path__ + "img/14-SANGDRAGON.d9607733.jpg";